import React, { memo } from 'react';
import ArrowRight from 'svg/ArrowRight';
import Button, { ButtonLink, ButtonText } from 'components/Button';
import type { LearnMoreKey } from './data';

export type EventTypeCardProps = {
  title: string;
  isVairIntegrated: boolean;
  icon: string;
  getStartedHref: string;
  isRatingSession?: boolean;
  onLearnMore: (key: LearnMoreKey) => void;
  learnMoreKey: LearnMoreKey;
  /**
   * Set for event types behind a VAIR role check: "Get Started" calls this
   * instead of linking, so the gate can navigate or explain what's missing.
   */
  onGetStarted?: () => void;
  /** VAIR role check still in flight — keeps the gated CTA from being clicked early. */
  isLoading?: boolean;
};

const EventTypeCard = memo(function EventTypeCard({
  title,
  isVairIntegrated,
  icon,
  getStartedHref,
  isRatingSession,
  onLearnMore,
  learnMoreKey,
  onGetStarted,
  isLoading,
}: EventTypeCardProps) {
  return (
    <div className="relative overflow-hidden rounded-3xl  bg-color-bg-lightmode-invert">
      {isRatingSession && (
        <div className="absolute  inset-0 h-full w-full">
          <img src="/images/vair/vair-banner-bg.gif" alt="VAIR" />
        </div>
      )}
      <div className="relative flex h-full flex-col items-center  px-ds-xl py-ds-xl pt-ds-3xl text-color-text-lightmode-invert">
        <img
          src={icon}
          alt={title}
          className="mb-ds-xl h-[4.25rem] w-auto max-w-[6.25rem] object-contain"
        />
        <span className="typography-product-heading-desktop mb-2 text-center">{title}</span>
        {isVairIntegrated && (
          <div className="mb-ds-xl flex items-center gap-1">
            <img
              src="/images/vair/vair-white.png"
              alt="VAIR"
              className="h-3 w-auto  object-contain"
            />
            <span className="typography-product-caption text-color-text-lightmode-tertiary">
              integrated
            </span>
          </div>
        )}
        <div className="mt-auto flex w-full flex-col items-center gap-ds-xl">
          {onGetStarted ? (
            <Button
              variant="inverted"
              size="md"
              className="h-[2.62rem]"
              onClick={onGetStarted}
              loading={isLoading}
            >
              Get Started
            </Button>
          ) : (
            <ButtonLink variant="inverted" size="md" className="h-[2.62rem]" href={getStartedHref}>
              Get Started
            </ButtonLink>
          )}
          <ButtonText className="flex items-center gap-1" onClick={() => onLearnMore(learnMoreKey)}>
            Learn More
            <ArrowRight className="h-4 w-4" />
          </ButtonText>
        </div>
      </div>
    </div>
  );
});

export default EventTypeCard;
